<template>
  <div v-if="!isPng">
    <section
      class="text-center bg-img ignore"
      :class="isPng ? 'image-banner-wrapper' : 'bg-height-280'"
    >
      <div
        class="container-fluid bg-img video-box ignore"
        :class="isPng ? 'banner-aspect' : 'h-100'"
      >
        <img
          v-if="isPng"
          class="video-background"
          :src="bgVideo"
          :alt="title"
        />
        <video
          v-else
          class="video-background"
          :poster="bg"
          :src="bgVideo"
          loop
          playsinline
          muted="muted"
          autoplay="autoplay"
        ></video>

        <div class="layer" v-if="!isPng"></div>

        <div
          v-if="!isPng"
          class="row h-100 align-items-center relative-content"
        >
          <div class="col-12">
            <div class="breadcrumb-content pt-32">
              <p class="text-transform item-title">{{ title }}</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: "bGroundComponent",
  props: {
    bg: {
      type: String,
      default: require("../assets/img/imgs/bg4.png"),
    },
    title: String,
    bgVideo: {
      type: String,
    },
  },
  computed: {
    isPng() {
      if (!this.bgVideo) return false;
      return /\.(png|webp)($|\?)/i.test(this.bgVideo);
    },
    getTitle() {
      return function (title) {
        let str;
        const lang = window.translate.language.getCurrent();
        if (lang === "chinese_traditional") {
          str = "宣傳短片";
        } else if (lang === "english") {
          str = "Publicity Video";
        } else {
          str = title;
        }
        return str;
      };
    },
    getTitle2() {
      return function (title) {
        let str;
        const lang = window.translate.language.getCurrent();
        if (lang === "chinese_traditional") {
          str = "環境影響評估";
        } else if (lang === "english") {
          str = "EM&A Information ";
        } else {
          str = title;
        }
        return str;
      };
    },
    getTitle3() {
      return function (title) {
        let str;
        const lang = window.translate.language.getCurrent();
        if (lang === "chinese_traditional") {
          str = "區議會諮詢";
        } else if (lang === "english") {
          str = "Consultation with District Council";
        } else {
          str = title;
        }
        return str;
      };
    },
  },
  data() {
    return {
      isMobile: false,
    };
  },
  mounted() {
    const _that = this;
    _that.getEnv();
  },
  methods: {
    getEnv() {
      const userAgent = window.navigator.userAgent;
      if (/Mobile|Android|iPhone|iPod|iPad|Windows Phone/i.test(userAgent)) {
        this.isMobile = true;
        console.log("移动端");
      } else {
        this.isMobile = false;
        console.log("pc端");
      }
    },
  },
};
</script>

<style scoped lang="less">
.image-banner-wrapper {
  width: 100%;
  padding-top: 104px;
  background-color: #27273d !important;
}

.banner-aspect {
  width: 100%;
  aspect-ratio: 1920 / 580;
  max-height: 580px;
}

.video-box {
  position: relative;
  background-color: #c1cff7;
  overflow: hidden;
}

.video-box .video-background {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 100%;
  height: 100%;
  object-fit: cover;
}

section:not(.image-banner-wrapper) .video-background {
  min-height: 800px;
}

.relative-content {
  position: relative;
  z-index: 2;
}

.layer {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 179, 170, 0.3);
  z-index: 1;
}

.item-title {
  font-size: 3rem;
  font-weight: 500;
  text-shadow: 0 0 10px #000;
  line-height: 35px;
  color: #fff;
  font-family: "Noto Sans SC", "Microsoft JhengHei", "Microsoft YaHei",
    Helvetica, Arial, sans-serif;
}

@media only screen and (min-width: 768px) and (max-width: 991px) {
  .item-title {
    font-size: 1.5rem !important;
  }
}

@media only screen and (max-width: 767px) {
  .image-banner-wrapper {
    padding-top: 80px;
  }

  .item-title {
    font-size: 2rem !important;
  }
}
</style>
